import { numberToString } from '@/utils/exponential'

interface Params {
  value: string | number
  isFiat: boolean
  maxPrecision?: number
  full?: boolean
}

export const getPrecision = ({ value, isFiat, maxPrecision, full }: Params) => {
  if (typeof maxPrecision === 'number') {
    return maxPrecision
  }

  const numberValue = Number(value)
  const stringValue = numberToString(value)

  const decimalPart = stringValue.split('.')[1]

  if (!decimalPart) {
    return 0
  }

  if (full) {
    return decimalPart.length
  }

  const isBigNumber = Math.abs(numberValue) >= 1e6
  if (isBigNumber) {
    return 0
  }

  const maxSignificant = isFiat ? 2 : 8

  const isSmallNumber = Math.abs(numberValue) < 1

  if (isSmallNumber) {
    const indexOfFirstSignificant = decimalPart.search(/[1-9]/)
    return Math.max(indexOfFirstSignificant + 2, maxSignificant)
  }

  return maxSignificant
}
